// @ts-nocheck
import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Iframe from "react-iframe";

export default function LandingPage() {
  // iframe 
  const [iframe, setIframe] = React.useState('');
// iframe の高さを画面サイズに合わせて調整する関数
  const screenHeight = window.innerHeight; // 現在の画面の高さ
  const screenWidth = window.innerWidth; // 現在の画面の幅
  const defaultMaxHeight = screenHeight/2-5 + 'px'; // iframe の高さを設定
  const [maxHeight, setMaxHeight] = React.useState(defaultMaxHeight);
  const maxWidth = screenWidth-20 + 'px'; // iframe の幅を設定
  const [ipLocation, setLocation] = React.useState('');
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [count, setCount] = React.useState(0);
  
  React.useEffect(() => {
    let counter =0;
       const timerId = setInterval(function(){
        if(document.getElementById("iframe") !== null ){
        if(document.getElementById("target").textContent !== ""){
        setLocation(document.getElementById("target").textContent);
        setMaxHeight(document.getElementById("target2").textContent);
        clearInterval(timerId);
        }}
        if(++counter > 99999){ 
            clearInterval(timerId);
          }
          }, 100);
    });

  return (
    <Box
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 0 },
          pb: { xs: 0, sm: 0 },
        }}
      >
{ipLocation =="JP" && <Iframe src="/cookie.1.html"  width={maxWidth}  height={maxHeight}  frameborder="0" style="border:0px" allowfullscreen ></Iframe>}
<Iframe　id="iframe" src="/cookie.html"  width={maxWidth} height={maxHeight} frameborder="0" style="border:0px" allowfullscreen ></Iframe>
      </Container></Box>

  );
}
